<template>
  <tr style="margin-top: 50px" :class="place ? 'chart' : 'vote'">
    <td>
      <h1
        class="success--text"
        :style="
          place ? 'font-size: 35px !important' : 'font-size: 65px !important'
        "
      >
        {{ place }}
      </h1>
    </td>
    <td>
      <v-avatar
        :size="place ? 70 : 125"
        :style="place ? 'width: 70px;' : 'width: 125px;'"
      >
        <img :src="partecipante.avatar" />
      </v-avatar>
    </td>
    <td>
      <h1 v-html="computedRagSoc"></h1>
    </td>
    <td>
      <v-layout row wrap justify-center>
        <v-card
          style="
            padding: 10px;
            min-width: 180px;
            text-align: center;
            margin: 0px;
          "
          color="success"
          dark
        >
          <h1>
            {{
              partecipante.totalToVote === 1 || partecipante.totVoti > 1
                ? partecipante.score.toFixed(3)
                : "?"
            }}
          </h1>
        </v-card>
      </v-layout>
    </td>
    <td>
      <v-layout row wrap justify-center>
        <div
          :v-if="partecipante.voti.length > 1"
          v-for="punteggio in partecipante.voti"
          :key="punteggio.masterId"
        >
          <v-avatar
            v-if="punteggio.score && type === 'P'"
            color="primary"
            size="50"
            style="margin: 10px"
          >
            <span class="white--text headline">{{
              partecipante.status !== "voting" ? punteggio.score : "?"
            }}</span>
          </v-avatar>
          <v-card
            style="padding: 10px; margin: 10px"
            v-if="punteggio.score && type === 'T'"
            color="primary"
            dark
          >
            <h1>
              {{ partecipante.status !== "voting" ? punteggio.score : "?" }}
            </h1>
          </v-card>
        </div>
        <!-- penalità -->
        <div
          v-if="
            partecipante.penalitaGiudici && partecipante.penalitaGiudici < 0
          "
          style="margin: 10px"
        >
          <v-avatar v-if="type === 'P'" color="red" size="50">
            <span class="white--text headline">{{
              partecipante.penalitaGiudici
            }}</span>
          </v-avatar>
          <v-card style="padding: 10px" v-else color="primary" dark>
            <h1>{{ partecipante.penalitaGiudici }}</h1>
          </v-card>
        </div>
      </v-layout>
    </td>
  </tr>
</template>

<script>
export default {
  name: "view-match-score",

  props: {
    partecipante: {},
    type: "",
    place: 0,
  },
  computed: {
    computedRagSoc() {
      return (
        this.$t("routine") +
        ": &nbsp;" +
        this.partecipante.ordine +
        "<br />" +
        this.partecipante.ragSoc
      );
    },
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
tr.chart {
  /* margin: 50px; */
  background-color: rgba(255, 255, 255, 0.9);
}
tr.vote {
  /* margin: 50px; */
  background-color: rgba(254, 216, 177, 0.9);
}
tr td:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
tr td:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
td {
  margin: 5px;
  padding: 5px;
}
</style>